import type { ResultType } from './typings'
const getSliderParam = (obj: any, name: string, unit?: number) => {
  const res = {}
  const key = name.slice(2).toLocaleLowerCase()
  unit = unit || 1
  if (obj.select1 && obj.select1.value !== -2) {
    if (typeof obj.select1.value === 'string') {
      const val = obj.select1.value.split('-')
      res[name + '_min'] = Number(val[0])
      if (val[1] === 'max') {
        res[name + '_max'] = unit === 1 ? obj.max : Math.ceil(obj.max * unit)
      } else {
        res[name + '_max'] = Number(val[1])
      }
    } else if (obj.select1.value === -1) {
      if (['m_fundDutaion', 'm_fundScale'].indexOf(name) > -1) {
        // 基金成立年限,基金规模 不支持传-1，处理成全域
        res[name + '_min'] = unit === 1 ? obj.min : Math.floor(obj.min * unit * 100) / 100
        res[name + '_max'] = unit === 1 ? obj.max : Math.ceil(obj.max * unit * 100) / 100
      } else {
        res[name] = -1
      }
    }
  } else if (obj.range) {
    res[name + '_min'] = unit === 1 ? obj.range[0] : Math.floor(obj.range[0] * unit * 100) / 100
    res[name + '_max'] = unit === 1 ? obj.range[1] : Math.ceil(obj.range[1] * unit * 100) / 100
  } else {
    // 必传值，取全域值
    res[name + '_min'] = unit === 1 ? obj.min : Math.floor(obj.min * unit * 100) / 100
    res[name + '_max'] = unit === 1 ? obj.max : Math.ceil(obj.max * unit * 100) / 100
  }
  return res
}
const getGroupParam = (obj: any, name: string) => {
  const res = {}
  if (!obj.select1 || obj.select1.value === -100) return res
  if (obj.select2) {
    if (obj.select2.value === -1) {
      res[name + '_min'] = 0
      res[name + '_max'] = 1
    } else if (typeof obj.select2.value === 'string') {
      const val = obj.select2.value.split('-')
      res[name + '_min'] = Number(val[0]) / 100
      res[name + '_max'] = Number(val[1]) / 100
    }
  } else {
    res[name + '_min'] = obj.range[0] / 100
    res[name + '_max'] = obj.range[1] / 100
  }
  res[name + '_time'] = obj.select1.value
  return res
}
const handleParams = (result: ResultType):any => {
  // debugger
  const { FundType } = result
  // console.log('pageData.result', result)
  const mFundType = FundType?.reduce((pre, cur) => (Number(pre) || 0) + (Number(cur) || 0), 0)
  let params: any = {}
  const mFundDutaion = getSliderParam(result.FundDutaion, 'm_fundDutaion', 365)
  const mFundScale = getSliderParam(result.FundScale, 'm_fundScale', 100000000)
  const mFundRatio = getSliderParam(result.FundRatio, 'm_fundRatio', 0.01)
  const mFundConcentration = getSliderParam(result.FundConcentration, 'm_fundConcentration', 0.01)
  const mManAge = getSliderParam(result.ManAge, 'm_manAge', 1)
  const mManScale = getSliderParam(result.ManScale, 'm_manScale', 1)
  const mManNum = getSliderParam(result.ManNum, 'm_manNum', 1)
  // 非必填
  const mFundProfit = getGroupParam(result.FundProfit, 'm_fundProfit')
  const mFundSharp = getGroupParam(result.FundSharp, 'm_fundSharp')
  const mFundDrawBack = getGroupParam(result.FundDrawBack, 'm_fundDrawBack')
  const mManProfit = getGroupParam(result.ManProfit, 'm_manProfit')
  const mManSharp = getGroupParam(result.ManSharp, 'm_manSharp')
  const mManDrawBack = getGroupParam(result.ManDrawBack, 'm_manDrawBack')
  params = {
    m_fundType: mFundType,
    ...mFundDutaion,
    ...mFundScale,
    ...mFundRatio,
    ...mFundConcentration,
    ...mManAge,
    ...mManScale,
    ...mManNum,
    ...mFundProfit,
    ...mFundSharp,
    ...mFundDrawBack,
    ...mManProfit,
    ...mManSharp,
    ...mManDrawBack
  }
  let url = 'gw://funccall?funcname=JJXGFilterEvent;param=<params>'
  // gw://funccall?funcname=JJXGFilterEvent;param=<params><m_fundType>1</m_fundType><m_fundDutaion_min>10</m_fundDutaion_min></params>
  Object.keys(params).forEach((name: string) => {
    url += `<${name}>${params[name]}</${name}>`
  })
  url += '</params>'
  // console.log('筛选', params)
  // console.log('筛选 url', url)
  if (location.hostname !== 'localhost') {
    window.open(url)
  }
}
export { handleParams }
